import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import piHomeDataStatistics from "./components/pi-home-data-statistics/pi-home-data-statistics.vue";
import piHomeChargeIncome from "./components/pi-home-charge-income/pi-home-charge-income.vue";
import piHomeSiteRanking from "./components/pi-home-site-ranking/pi-home-site-ranking.vue";
import piHomeContentMap from "./components/pi-home-content-map/pi-home-content-map.vue";
import piHomeAssets from "./components/pi-home-assets/pi-home-assets.vue";
import piHomeGunEchart from "./components/pi-home-gun-echart/pi-home-gun-echart.vue";
import { echartsJS } from "@/common/add-js";
import { State } from "vuex-class";
// import i18n from "@/config/i18n";
let PiHome = class PiHome extends Vue {
    constructor() {
        super(...arguments);
        this.isEchart = false;
    }
    async echartInit() {
        await echartsJS();
        this.isEchart = true;
    }
    mounted() {
        this.echartInit();
    }
};
__decorate([
    State("sys")
], PiHome.prototype, "sys", void 0);
PiHome = __decorate([
    Component({
        components: {
            "pi-home-data-statistics": piHomeDataStatistics,
            "pi-home-charge-income": piHomeChargeIncome,
            "pi-home-site-ranking": piHomeSiteRanking,
            "pi-home-content-map": piHomeContentMap,
            "pi-home-assets": piHomeAssets,
            "pi-home-gun-echart": piHomeGunEchart,
        },
    })
], PiHome);
export default PiHome;
